import { Pipe, PipeTransform } from '@angular/core';
import { CertificateDto } from 'src/app/models/trofaco/certificateDto';

@Pipe({
    name: 'onlyVisibleDonor'
})
export class OnlyVisibleDonorPipe implements PipeTransform {

    transform(certificates: CertificateDto[]): CertificateDto[] {
        return certificates.filter((c: CertificateDto) => {
            return c.isShow;
        });
    }

}
